import type { FluidFrictionPrerequisites } from "../d";
import { BeggsBrillFlowRegimes } from "../../tubingFrictionLoss/beggsBrill";

export function getFlowRegimeBeggsBrill(
  flowRegimePrerequisites: FluidFrictionPrerequisites
): BeggsBrillFlowRegimes {
  const { froudeNumber, froudeTransitionNumbers, noSlipLiquidHoldupLambdaCL } =
    flowRegimePrerequisites;
  if (noSlipLiquidHoldupLambdaCL > 0.999) {
    return BeggsBrillFlowRegimes.LIQUID;
  } else if (
    (noSlipLiquidHoldupLambdaCL < 0.01 &&
      froudeNumber < froudeTransitionNumbers[0]) ||
    (noSlipLiquidHoldupLambdaCL >= 0.01 &&
      froudeNumber < froudeTransitionNumbers[1])
  ) {
    return BeggsBrillFlowRegimes.SEGREGATED;
  } else if (
    (noSlipLiquidHoldupLambdaCL >= 0.4 &&
      froudeNumber > froudeTransitionNumbers[2] &&
      froudeNumber <= froudeTransitionNumbers[3]) ||
    (noSlipLiquidHoldupLambdaCL < 0.4 &&
      noSlipLiquidHoldupLambdaCL >= 0.01 &&
      froudeNumber <= froudeTransitionNumbers[0] &&
      froudeNumber > froudeTransitionNumbers[2])
  ) {
    return BeggsBrillFlowRegimes.INTERMITTENT;
  } else if (
    (noSlipLiquidHoldupLambdaCL < 0.4 &&
      froudeNumber >= froudeTransitionNumbers[3]) ||
    (noSlipLiquidHoldupLambdaCL >= 0.4 &&
      froudeNumber > froudeTransitionNumbers[3])
  ) {
    return BeggsBrillFlowRegimes.DISTRIBUTED;
  } else if (
    noSlipLiquidHoldupLambdaCL >= 0.01 &&
    froudeNumber > froudeTransitionNumbers[1] &&
    froudeNumber < froudeTransitionNumbers[2]
  ) {
    return BeggsBrillFlowRegimes.TRANSITION;
  } else {
    return BeggsBrillFlowRegimes.LIQUID;
  }
}
